import { RouteConfig } from 'vue-router';
import Dashboard from '@/views/default/Dashboard.vue';
import notifications from '@/views/default/Notifications.vue';
import PageNotFound from '@/views/default/PageNotFound.vue';
import Forbidden from '@/views/default/Forbidden.vue';
import BlobViewer from '@/utils/BlobViewer.vue';
import PageModal from '@/components/modals/PageModal.vue';
import DashboardVideoModal from '@/views/default/DashboardVideoModal.vue';
import store from '@/store';

const routes: Array<RouteConfig> = [
	{
		path: '/',
		redirect: '/dashboard',
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: Dashboard,
		children: [
			{
				path: 'dashboard_show_video/:videoId',
				name: 'dashboard.show_video',
				component: PageModal,
				props: {
					component: DashboardVideoModal,
					title: () => (store.getters.getModalTitle ? store.getters.getModalTitle : 'Video ansehen'),
					saveButtonText: null,
					props: true,
				},
			},
		],
	},
	{
		path: '/notifications',
		name: 'notifications',
		component: notifications,
	},
	{
		path: '/forbidden',
		name: 'Forbidden',
		component: Forbidden,
	},
	{
		path: '/blobviewer',
		name: 'BlobViewer',
		component: BlobViewer,
		meta: {
			guest: true,
		},
	},
	{
		path: '*',
		name: 'PageNotFound',
		component: PageNotFound,
	},
];

export default routes;
